import Alpine from 'alpinejs';

import type ScrollLock from '../scroll_lock/scroll_lock';
import ModalStore from './modal';

export const getModalStore = (scrollLock: ScrollLock): ModalStore => {
    if (!Alpine.store('modal')) {
        Alpine.store('modal', new ModalStore(scrollLock));
    }

    return Alpine.store('modal') as ModalStore;
};
